import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es5.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es5.js';
import '@sparta.global.utilities/recalculate-sticky-utility/dist/es5.js';
import '@sparta.global.utilities/sparta-sticky-utility/dist/es5.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es5.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es5.js';
var Template = Handlebars.template({
  "1": function _(container, depth0, helpers, partials, data) {
    return "      ada-hidden\r\n";
  },
  "3": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "      " + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "isSticky") : stack1, {
      "name": "if",
      "hash": {},
      "fn": container.program(4, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 7,
          "column": 6
        },
        "end": {
          "line": 7,
          "column": 46
        }
      }
    })) != null ? stack1 : "") + "\r\n      " + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "flagscape") : stack1, {
      "name": "if",
      "hash": {},
      "fn": container.program(6, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 8,
          "column": 6
        },
        "end": {
          "line": 8,
          "column": 66
        }
      }
    })) != null ? stack1 : "") + "\r\n      " + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "skin") : stack1, {
      "name": "if",
      "hash": {},
      "fn": container.program(8, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 9,
          "column": 6
        },
        "end": {
          "line": 9,
          "column": 63
        }
      }
    })) != null ? stack1 : "") + "\r\n      " + ((stack1 = (lookupProperty(helpers, "compare") || depth0 && lookupProperty(depth0, "compare") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "textColor") : stack1, "!=", "none", {
      "name": "compare",
      "hash": {},
      "fn": container.program(10, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 10,
          "column": 6
        },
        "end": {
          "line": 10,
          "column": 100
        }
      }
    })) != null ? stack1 : "") + "\r\n";
  },
  "4": function _(container, depth0, helpers, partials, data) {
    return "spa-sticky";
  },
  "6": function _(container, depth0, helpers, partials, data) {
    return "spa-page-title--has-flagscape";
  },
  "8": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "spa-page-title--" + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "skin") : stack1, depth0));
  },
  "10": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "spa-page-title--" + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "textColor") : stack1, depth0)) + "-text";
  },
  "12": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "    data-sticky-full-width=\"true\"\r\n" + ((stack1 = lookupProperty(helpers, "unless").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "isVisuallyHidden") : stack1, {
      "name": "unless",
      "hash": {},
      "fn": container.program(13, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 15,
          "column": 4
        },
        "end": {
          "line": 17,
          "column": 15
        }
      }
    })) != null ? stack1 : "");
  },
  "13": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "      data-sticky-level=\"" + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "stickyLevel") : stack1, depth0)) + "\"\r\n";
  },
  "15": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0, {
      "name": "each",
      "hash": {},
      "fn": container.program(16, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 23,
          "column": 8
        },
        "end": {
          "line": 49,
          "column": 17
        }
      }
    })) != null ? stack1 : "";
  },
  "16": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "unless").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "module")) && lookupProperty(stack1, "hideTitle"), {
      "name": "unless",
      "hash": {},
      "fn": container.program(17, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 24,
          "column": 10
        },
        "end": {
          "line": 48,
          "column": 21
        }
      }
    })) != null ? stack1 : "";
  },
  "17": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = (lookupProperty(helpers, "compare") || depth0 && lookupProperty(depth0, "compare") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, data && lookupProperty(data, "key"), "==", (stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "page")) && lookupProperty(stack1, "pageID"), {
      "name": "compare",
      "hash": {},
      "fn": container.program(18, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 25,
          "column": 12
        },
        "end": {
          "line": 47,
          "column": 24
        }
      }
    })) != null ? stack1 : "";
  },
  "18": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "              <" + ((stack1 = lookupProperty(helpers, "with").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "module")) && lookupProperty(stack1, "titleHeadingTag"), {
      "name": "with",
      "hash": {},
      "fn": container.program(19, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 26,
          "column": 15
        },
        "end": {
          "line": 26,
          "column": 72
        }
      }
    })) != null ? stack1 : "") + "\r\n                data-font=\"cnx-regular\"\r\n                class=\"heading title-heading\"\r\n                id=\"skip-to-h1\"\r\n                " + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "module")) && lookupProperty(stack1, "titleHeadingRole"), {
      "name": "if",
      "hash": {},
      "fn": container.program(21, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 30,
          "column": 16
        },
        "end": {
          "line": 30,
          "column": 100
        }
      }
    })) != null ? stack1 : "") + "\r\n                " + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "module")) && lookupProperty(stack1, "setAriaLevel1"), {
      "name": "if",
      "hash": {},
      "fn": container.program(23, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 31,
          "column": 16
        },
        "end": {
          "line": 31,
          "column": 71
        }
      }
    })) != null ? stack1 : "") + "\r\n              >\r\n" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "default") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(25, data, 0),
      "inverse": container.program(27, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 33,
          "column": 16
        },
        "end": {
          "line": 45,
          "column": 23
        }
      }
    })) != null ? stack1 : "") + "              </" + ((stack1 = lookupProperty(helpers, "with").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "module")) && lookupProperty(stack1, "titleHeadingTag"), {
      "name": "with",
      "hash": {},
      "fn": container.program(19, data, 0),
      "inverse": container.program(35, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 46,
          "column": 16
        },
        "end": {
          "line": 46,
          "column": 83
        }
      }
    })) != null ? stack1 : "") + ">\r\n";
  },
  "19": function _(container, depth0, helpers, partials, data) {
    var stack1;
    return (stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "";
  },
  "21": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "role=\"" + container.escapeExpression(container.lambda((stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "module")) && lookupProperty(stack1, "titleHeadingRole"), depth0)) + "\"";
  },
  "23": function _(container, depth0, helpers, partials, data) {
    return "aria-level=\"1\"";
  },
  "25": function _(container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "                  " + ((stack1 = (helper = (helper = lookupProperty(helpers, "default") || (depth0 != null ? lookupProperty(depth0, "default") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "default",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 34,
          "column": 18
        },
        "end": {
          "line": 34,
          "column": 31
        }
      }
    }) : helper)) != null ? stack1 : "") + "\r\n";
  },
  "27": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "small") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(28, data, 0),
      "inverse": container.program(30, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 36,
          "column": 18
        },
        "end": {
          "line": 44,
          "column": 25
        }
      }
    })) != null ? stack1 : "";
  },
  "28": function _(container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "                    " + ((stack1 = (helper = (helper = lookupProperty(helpers, "small") || (depth0 != null ? lookupProperty(depth0, "small") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "small",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 37,
          "column": 20
        },
        "end": {
          "line": 37,
          "column": 31
        }
      }
    }) : helper)) != null ? stack1 : "") + "\r\n";
  },
  "30": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "medium") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(31, data, 0),
      "inverse": container.program(33, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 39,
          "column": 20
        },
        "end": {
          "line": 43,
          "column": 27
        }
      }
    })) != null ? stack1 : "";
  },
  "31": function _(container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "                      " + ((stack1 = (helper = (helper = lookupProperty(helpers, "medium") || (depth0 != null ? lookupProperty(depth0, "medium") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "medium",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 40,
          "column": 22
        },
        "end": {
          "line": 40,
          "column": 34
        }
      }
    }) : helper)) != null ? stack1 : "") + "\r\n";
  },
  "33": function _(container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "                      " + ((stack1 = (helper = (helper = lookupProperty(helpers, "large") || (depth0 != null ? lookupProperty(depth0, "large") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "large",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 42,
          "column": 22
        },
        "end": {
          "line": 42,
          "column": 33
        }
      }
    }) : helper)) != null ? stack1 : "") + "\r\n";
  },
  "35": function _(container, depth0, helpers, partials, data) {
    return "h1";
  },
  "37": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "children") : depth0, {
      "name": "each",
      "hash": {},
      "fn": container.program(38, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 53,
          "column": 8
        },
        "end": {
          "line": 55,
          "column": 17
        }
      }
    })) != null ? stack1 : "";
  },
  "38": function _(container, depth0, helpers, partials, data) {
    var stack1;
    return "          " + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "") + "\r\n";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<div\r\n  class=\"\r\n    spa-page-title\r\n" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "isVisuallyHidden") : stack1, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.program(3, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 4,
          "column": 4
        },
        "end": {
          "line": 11,
          "column": 11
        }
      }
    })) != null ? stack1 : "") + "  \"\r\n" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "module") : depth0) != null ? lookupProperty(stack1, "isSticky") : stack1, {
      "name": "if",
      "hash": {},
      "fn": container.program(12, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 13,
          "column": 2
        },
        "end": {
          "line": 18,
          "column": 9
        }
      }
    })) != null ? stack1 : "") + ">\r\n  <div class=\"spa-page-title-inset row\">\r\n    <div class=\"column\">\r\n" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "sitePageTitles") : depth0) != null ? lookupProperty(stack1, "pageTitles") : stack1, {
      "name": "each",
      "hash": {},
      "fn": container.program(15, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 22,
          "column": 6
        },
        "end": {
          "line": 50,
          "column": 15
        }
      }
    })) != null ? stack1 : "") + "\r\n" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "children") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(37, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 52,
          "column": 6
        },
        "end": {
          "line": 56,
          "column": 13
        }
      }
    })) != null ? stack1 : "") + "    </div>\r\n  </div>\r\n</div>";
  },
  "useData": true
});
var renderTemplate = function renderTemplate(data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global.modules/title-module",
  "version": "1.0.32",
  "id": "titleModule",
  "containerID": "globalTitleModule",
  "moduleName": "global-title-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "title-module",
  "data": {
    "init": "titleModuleJS",
    "options": {
      "isSticky": "{{module.isSticky}}",
      "stickyLevel": "{{module.stickyLevel}}"
    }
  },
  "moduleParams": [{
    "name": "skin",
    "type": "string",
    "values": ["red", "gray", "transparent", "red-gradient"],
    "default": "red",
    "description": "This parameter controls the color of the title"
  }, {
    "name": "isSticky",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter applies fixed postion to title bar"
  }, {
    "name": "secondarySticky",
    "type": "string",
    "values": [],
    "default": "",
    "description": "This parameter applies fixed postion to element passed by id on scroll"
  }, {
    "name": "flagscape",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter controls whether or not a flagscape is included in the title"
  }, {
    "name": "textColor",
    "type": "string",
    "values": ["red", "black", "white", "none"],
    "default": "none",
    "description": "This parameter allows for overriding the default text color of a skin."
  }, {
    "name": "titleHeadingTag",
    "type": "string",
    "values": ["h1", "h2", "p"],
    "default": "h1",
    "description": "This parameter allows for overriding the default heading in the title.  Some pages have their own h1 tag."
  }, {
    "name": "titleHeadingRole",
    "type": "string",
    "values": [],
    "default": "heading",
    "description": "This parameter allows for overriding the default role heading in the title. Introduced due to JAWS / screen readers picking it up as a landmark when not intended."
  }, {
    "name": "pageTitleId",
    "type": "string",
    "values": ["global-footer-demo"],
    "default": "h1",
    "description": "This parameter allows for the ID of the title strip to be specified."
  }, {
    "name": "stickyLevel",
    "type": "number",
    "description": "Sticky utility element level.",
    "default": 1
  }, {
    "name": "hideTitle",
    "type": "boolean",
    "description": "This parameter allows to hide title."
  }, {
    "name": "setAriaLevel1",
    "type": "boolean",
    "description": "This parameter allows the developer to set arial-level=1 for ADA purposes.  Ref SPARTA-1963/DE131934"
  }, {
    "name": "isVisuallyHidden",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Allows the entire module to be visually hidden and only available to screen readers."
  }],
  "layout": "layout",
  "render": function render(context) {
    return renderTemplate(context, {
      "helpers": {
        compare: compare,
        json: json
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare: compare,
    json: json
  },
  "dependencies": {
    "@sparta.global.utilities/recalculate-sticky-utility": "^1.0.3",
    "@sparta.global.helpers/comparisons-helper": "^1.0.3",
    "@sparta.global.helpers/json-helper": "^1.0.2",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.2",
    "@sparta.global.utilities/sparta-module-utility": "^1.1.8",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.1.6",
    "@sparta.global.utilities/sparta-color-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-breakpoint-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7"
  },
  "stores": []
};
var EVENTS = {
  SPARTA_GLOBAL_READY: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility'
};
var mdaVars = {
  paramName: 'wrap',
  paramExpectedValue: 'mda',
  versionParamName: 'mda_app_version',
  expectedVersion: 7.9
};

/**
 * Class export.
 * @returns {void}
 */
var titleModuleJS = /*#__PURE__*/function (_Module) {
  function titleModuleJS(options, context) {
    _classCallCheck(this, titleModuleJS);
    return _callSuper(this, titleModuleJS, [_objectSpread(_objectSpread({}, options), {}, {
      context: context,
      config: _moduleConfig
    })]);
  }
  /**
   * Initialize the module.
   * @returns {void}
   */
  _inherits(titleModuleJS, _Module);
  return _createClass(titleModuleJS, [{
    key: "init",
    value: function init() {
      // Check for MDA parameter and version.
      var isMda = this.SpartaFunctions.getUrlParam(mdaVars.paramName) || this.Store.getPersisted(mdaVars.paramName);

      // Hardcoded until a param exists, like `mdaVars.versionParamName`.
      var mdaVersion = mdaVars.expectedVersion;

      // Continue MDA check.
      var isDefined = isMda !== undefined && isMda !== null;
      if (isDefined) {
        var isExpectedValue = isMda.toLowerCase() === mdaVars.paramExpectedValue && mdaVersion >= mdaVars.expectedVersion;
        if (isExpectedValue) {
          this.Store.persist(mdaVars.paramName, mdaVars.paramExpectedValue);
        }
      }
      spartaEventsUtility.sub(EVENTS.SPARTA_GLOBAL_READY, function () {
        // hide/show the title module for newer/older versions of MDA.
        // Need to hide by default. Show if not MDA to prevent flashing on page.
        /**
        * Function for retrieving URL params from address.
        * @returns Array of params
        */
        function getUrlVars() {
          var vars = {};
          window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
          });
          return vars;
        }
        var mdaVersion = 7.9; // Hardcoded until a param exists, like `getUrlVars()['mda_app_version']`.
        var spartaStorage = window.localStorage.sparta;
        var wrapParam = getUrlVars()[mdaVars.paramName] || (spartaStorage ? spartaStorage.wrap : '');
        // Set boolean value for whether it's an MDA page with proper version. Also check the
        // localStorage in case it was cached on another page.
        var isMda = wrapParam !== undefined && wrapParam.toLowerCase() === mdaVars.paramExpectedValue || spartaStorage !== undefined && spartaStorage.indexOf("".concat(mdaVars.paramName, ":").concat(mdaVars.paramExpectedValue)) > 0;
        // If not an MDA page, or old MDA version, display the title module.
        if (!isMda || mdaVersion < mdaVars.expectedVersion) {
          var moduleContainer = document.querySelector('.title-module');
          if (moduleContainer) {
            moduleContainer.style.display = 'block';
          }
        }
      });
    }
  }]);
}(Module);
registerModuleClass({
  moduleClass: titleModuleJS,
  moduleConfig: _moduleConfig
});
var moduleConfig = _moduleConfig;
export { titleModuleJS as default, moduleConfig };